// React
import React from 'react';

// Components
import ProUpcomingBookings from 'components/Booking/ProUpcomingBookings';
// import CompletedBookings from './CompletedBookings';

class ProBookingModule extends React.Component {
    render = () => (
        <ProUpcomingBookings 
            serviceId={this.props.serviceId}
            serviceSbmId={this.props.serviceSbmId}
            providerData={this.props.providerData}
        />
    );
};

export default ProBookingModule;




// WEBPACK FOOTER //
// ./src/js/components/Booking/ProBookingModule.jsx